import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromStore from '../../../store';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { LicenseDetailActionTypes, LicenseDetailActions } from '../actions/license-detail.actions';
import { LicenseMgtService } from '../../../services/license-mgt.service';
import { Store } from '@ngrx/store';
import * as featureActions from '../../index';

@Injectable()
export class LicenseDetailEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);

  constructor() {}

  GetLicenseDetails$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseDetailActionTypes.GetLicenseDetails),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        Id: action.payload
      };
      return this.licenseMgtService.ReadLicenseDetails(params).pipe(
        switchMap((res) => {
          if (res.result && res.msg.body) {
            const data = res.msg.body;
            const dcodeList = (Array.isArray(data.UsedDevice)) ? data.UsedDevice.map(item => item.dcode) : null;
            return [new featureActions.LoadLicenseDetails(res.msg.body),
                    new featureActions.GetDevices(dcodeList)];
          } else {
            return of(new featureActions.GetLicenseDetailsFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.GetLicenseDetailsFail());
        })
      );
    })
  ));

}
